import { useRemoteQuery } from "../../useRemote/useRemoteQuery";
import { OrderRequestData } from "../../../../components/ServiceManagement/OrderRequests/Domain/RemoteOrderRequests.types";

export type FetchOrderRequestDto = {
  dateFrom: string;
  dateTo: string;
};

/**
 * GET the order requests by selected date
 */
export function useRemoteFetchOrderRequests(dto: FetchOrderRequestDto) {
  return useRemoteQuery<OrderRequestData[]>({
    queryKey: `fetch-order-requests-${dto.dateFrom}`,
    url: "/service-booking/service-bookings",
    params: dto,
    enabled: !!dto.dateFrom && !!dto.dateTo
  });
}
